import axios from 'axios'

function initialState() {
  return {
    stationMetadata: [],
    metaDataOrdinalStartIndex: 3,
  }
}

const SET_METADATA = 'SET_METADATA'

const BASE_URL = 'api/Station/Metadata'
const UPSERT_URL = `${BASE_URL}/Upsert`

export default {
  namespaced: true,
  state: initialState,
  actions: {
    async getStationMetadata({
      dispatch,
      commit,
      state,
    }, stationId) {
      let url = 'api/Station/Metadata/List/' + stationId
      axios.get(url)
        .then((res) => {
          var list = JSON.parse(JSON.stringify(res.data))
          for (let i = 0; i < list.length; i++) {
            if (list[i].Ordinal != i + state.metaDataOrdinalStartIndex) {
              list[i].Ordinal = i + state.metaDataOrdinalStartIndex
              dispatch('updateMetaData', list[i])
            }
          }
          commit('SET_STATIONMETADATA', list)
        })
        .catch(() => {
          console.log('Could not get meta data from \'' + url + '\'')
        })
    },
    async deleteMetaData({
      commit,
    }, metaDataId) {
      let url = 'api/Station/Metadata/Delete/' + metaDataId
      axios.delete(url)
        .then(() => {
          commit('SET_DELETE_STATIONMETADATA', metaDataId)
        })
        .catch(() => {
          console.log('Station meta data delete failed')
        })
    },
    async updateMetaData({
      commit,
    }, metaDataToUpdate) {
      let url = 'api/Station/Metadata/Update'
      let data = {
        Id: metaDataToUpdate.Id,
        Field: metaDataToUpdate.Field,
        FieldValue: metaDataToUpdate.FieldValue,
        FieldType: metaDataToUpdate.FieldType,
        Ordinal: metaDataToUpdate.Ordinal,
      }
      axios.put(url, data)
        .then(() => {
          commit('SET_SINGLE_METADATA', metaDataToUpdate)
        })
        .catch(() => {
          console.log('Station meta data update failed')
        })
    },
    async upsertMetadata({
        commit,
      },
      metadata,
    ) {

      try {
        let res = await axios.post(UPSERT_URL, metadata)
        commit(SET_METADATA, res.data)
      } catch (error) {
        console.error('Station meta data add failed', error)
        throw error
      }
      // axios.post(url, data)
      //   .then((res) => {
      //     var newMetaData = res.data
      //     commit('ADD_SINGLE_METADATA', newMetaData)
      //   })
      //   .catch(() => {
      //     console.log('Station meta data add failed')
      //   })
    },
  },

  mutations: {
    SET_STATIONMETADATA(s, v) {
      s.stationMetadata = v.concat([]).sort((a, b) => {
        return a.Ordinal - b.Ordinal
      })
    },
    RESET(state) {
      const s = initialState()
      Object.keys(s).forEach(key => {
        state[key] = s[key]
      })
    },
    SET_DELETE_STATIONMETADATA(s, metaDataId) {
      //deep copy the data for update
      var dc = JSON.parse(JSON.stringify(s.stationMetadata))
      var i = dc.findIndex(x => x.Id == metaDataId)
      dc.splice(i, 1)
      for (; i < dc.length; i++) {
        dc[i].Ordinal = i + 3
      }
      s.stationMetadata = dc
    },
    SET_SINGLE_METADATA(s, v) {
      var dc = JSON.parse(JSON.stringify(s.stationMetadata))
      var matched = dc.find(x => x.Id == v.Id)
      matched.FieldValue = v.FieldValue
      matched.Field = v.Field
      var matchedOrdinal = dc.find(x => x.Ordinal == v.Ordinal)
      if (matchedOrdinal != null) {
        var temp = matchedOrdinal.Ordinal
        matchedOrdinal.Ordinal = matched.Ordinal
        matched.Ordinal = temp
      } else {
        matched.Ordinal = v.Ordinal
      }

      s.stationMetadata = dc.concat([]).sort((a, b) => {
        return a.Ordinal - b.Ordinal
      })
    },
    [SET_METADATA](state, metadata) {
      state.stationMetadata = metadata
    },
  },

  getters: {
    stationMetadata: s => {
      return s.stationMetadata
    },
    metaDataOrdinalStartIndex: s => {
      return s.metaDataOrdinalStartIndex
    },
  },
}